import { Injectable } from '@angular/core';
import { DEFAULT_LANGUAGE, InternationalizationService, SupportedLanguage } from '@examdojo/core/i18n';

const LANGUAGE_SETTING_STORAGE_KEY = 'user_language';

@Injectable({ providedIn: 'root' })
export class LanguageService extends InternationalizationService {
  override setActiveLang(lang: SupportedLanguage) {
    super.setActiveLang(lang);
    localStorage.setItem(LANGUAGE_SETTING_STORAGE_KEY, lang);
  }

  loadLanguageFromLocalStorage() {
    const lang = (localStorage.getItem(LANGUAGE_SETTING_STORAGE_KEY) as SupportedLanguage | null) ?? DEFAULT_LANGUAGE;
    super.setActiveLang(lang);
  }
}
